import styled from '@emotion/styled';
import { N200 } from '@atlaskit/theme/colors';
import { grid } from '../style-utils';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var FilterGroupTitle = styled.div({
  fontSize: '11px',
  lineHeight: grid.multiple(2).px,
  fontWeight: 600,
  textTransform: 'uppercase',
  color: "var(--ds-text-subtle, ".concat(N200, ")"),
  paddingBottom: grid.multiple(0.5).px
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var SkeletonContainer = styled.div({
  width: '100%'
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var FilterGroupContainer = styled.div({
  ':not(:first-of-type)': {
    paddingTop: grid.multiple(3.5).px
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
export var FilterResultRowContainer = styled.div({
  display: 'flex',
  justifyContent: 'left',
  alignItems: 'center'
});